import { render } from "./Trend.vue?vue&type=template&id=5c103a0a"
import script from "./Trend.vue?vue&type=script&lang=js"
export * from "./Trend.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/index/components/Trend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c103a0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c103a0a', __exports__)) {
    console.log('reload')
    api.reload('5c103a0a', __exports__)
  }
  
  module.hot.accept("./Trend.vue?vue&type=template&id=5c103a0a", () => {
    console.log('re-render')
    api.rerender('5c103a0a', render)
  })

}


export default __exports__